import React from 'react'
import propTypes from 'prop-types'
import { Chart } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { buildChartJsOptionsProp } from './options'
import { getChartHeight } from '@utils/heights'

export const BarChart = (props) => {
  Chart.register(ChartDataLabels)

  return (
    <div className={props.className} style={{ height: getChartHeight(props.height) }}>
      <Bar
        options={buildChartJsOptionsProp(props.options)}
        data={props.data}
        plugins={props.plugins}
      />
    </div>
  )
}

BarChart.propTypes = {
  className: propTypes.string,
  datasets: propTypes.array.isRequired,
  labels: propTypes.array.isRequired,
  height: propTypes.string,
  options: propTypes.object,
  plugins: propTypes.array,
}

BarChart.defaultProps = {
  className: '',
  height: '',
  options: {},
}
